import type { ReactNode } from 'react';

import { Field } from 'components/Form/Field/Field';
import type { FieldCustomErrorMatcher } from 'components/Form/Field/FieldCustomErrorMatcher';
import { RadioButtons } from 'components/Radio/RadioButtons';

type Props = {
  'data-qa-id'?: string;
  name: string;
  nameOverride?: string;
  label?: ReactNode;
  disabled?: boolean;
  required?: boolean;
  description?: ReactNode;
  buttons: {
    label: ReactNode;
    value: string | boolean | number;
    disabled?: boolean;
  }[];
  large?: boolean;
  square?: boolean;
  onChange?: (
    newValue: string | boolean | number | null | (string | boolean | number)[],
  ) => void;
  alignTop?: boolean;
  columns?: 1 | 2 | number[];
  canDeselect?: boolean;
  value?: string | boolean | number | null | (string | boolean | number)[];
  customErrorMatch?: FieldCustomErrorMatcher;
};

export function RadioButtonsField({
  name,
  nameOverride,
  label,
  description,
  buttons,
  large,
  alignTop,
  columns,
  canDeselect,
  onChange,
  customErrorMatch,
  ...props
}: Props) {
  return (
    <Field
      inputProps={props}
      name={name}
      nameOverride={nameOverride}
      label={label}
      description={description}
      customErrorMatch={customErrorMatch}
      renderInput={({ value, id, qaId, hasError, updateValue }) => {
        const update = (
          newValue:
            | string
            | boolean
            | number
            | null
            | (string | boolean | number)[],
        ) => {
          updateValue(newValue);

          if (onChange) {
            onChange(newValue);
          }
        };

        return (
          <RadioButtons
            id={id}
            name={name}
            value={value}
            buttons={buttons}
            large={large}
            alignTop={alignTop}
            hasError={hasError}
            onChange={update}
            canDeselect={canDeselect}
            data-qa-id={qaId}
            columns={columns}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        );
      }}
    />
  );
}
